import { getGlobalWheres } from './helpers';

export default (axios) => {
  // Axios request interceptor
  axios.interceptors.request.use(config => {
    config.params = config.params || {};
    // Set BusinessScopeId and language from localStorage
    config.params.BusinessScopeId = localStorage.getItem('BusinessScopeId') || 1;
    config.headers['Accept-Language'] = localStorage.getItem('CurrentLanguage') || 'en';

    // Business scope and load configurations
    config.params.load = config.params.withoutLoadBusinessScope ? [...(config.params.load || [])] : [...(config.params.load || []), 'BusinessScope'];

    // Extract the base URL endpoint to identify the request type
    const urlEndpoint = config.url.split('?')[0].split('/')[0];
    let specificWheres = [];

    // Logic to populate specificWheres based on urlEndpoint
    if (urlEndpoint.includes('User') || urlEndpoint.includes('Users')) {
      let BusinessScopePath = localStorage.getItem('GEODIS');
      specificWheres = config.params.withoutGlobalBusinessScope ? [] : [`x => x.UserRoleBusinessScopes.Any(y => y.BusinessScope.Path.Contains("${BusinessScopePath}")) || x.DeletedAt != Null || (x.UserRoleBusinessScopes.count = 0 && x.DeletedAt == Null)`];
    } else if (urlEndpoint.includes('Portal')) {
      specificWheres = [`x => !x.Hidden && x.DeletedAt == null`];
    } else if (urlEndpoint.includes('EdiMap')) {
      specificWheres = [`x => x.Hidden && x.DeletedAt == null`];
    } else {
      // Fallback to globalWheres if none of the above conditions match
      specificWheres = config.params.withoutGlobalBusinessScope ? [] : getGlobalWheres();
    }

    // Remove duplicates and merge with existing params
    const uniqWheres = [...new Set(specificWheres.concat(config.params.where || []))];
    config.params.where = uniqWheres;

    // Return the modified config object
    return config;
  }, error => Promise.reject(error));

  // Set axios default configurations
  axios.defaults.baseURL = (window.envConfig || {}).VUE_APP_API_ENDPOINT || process.env.VUE_APP_API_ENDPOINT;
  axios.defaults.headers.common = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
};
